"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDatasetWriteAccess = exports.getIsFeatureAllowed = exports.AllFeatures = exports.getIsCurrentDatasetOwner = void 0;
const reselect_1 = require("reselect");
const auth_1 = require("companion-app-components/flux/auth");
const datasets_1 = require("companion-app-components/flux/datasets");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const getDatasetId = (state) => auth_1.authSelectors.getDatasetId(state);
const getDatasets = (state) => datasets_1.datasetsSelectors.getActiveDatasets(state);
const getWebFirstDataset = (state) => auth_1.authSelectors.getIsWebfirstDataset(state);
exports.getIsCurrentDatasetOwner = (0, reselect_1.createSelector)(getDatasetId, getDatasets, (datasetId, datasets) => {
    const currentDataset = datasets === null || datasets === void 0 ? void 0 : datasets.get(datasetId);
    if (!currentDataset)
        return false;
    const ownDatasets = datasets === null || datasets === void 0 ? void 0 : datasets.filter((dataset) => !dataset.shared);
    return ownDatasets === null || ownDatasets === void 0 ? void 0 : ownDatasets.has(currentDataset.id);
});
var AllFeatures;
(function (AllFeatures) {
    AllFeatures["ADD_ACCOUNTS"] = "ADD_ACCOUNTS";
    AllFeatures["ADD_BUDGET"] = "ADD_BUDGET";
    AllFeatures["FIX_ACCOUNT"] = "FIX_ACCOUNT";
})(AllFeatures = exports.AllFeatures || (exports.AllFeatures = {}));
exports.getIsFeatureAllowed = (0, reselect_1.createSelector)(exports.getIsCurrentDatasetOwner, getWebFirstDataset, // eslint-disable-line function-call-argument-newline
(_state, type) => type, // eslint-disable-line function-call-argument-newline
(isCurrentDatasetOwner, isWebFirstDataset, type) => {
    const allowedFeatures = [];
    if (isCurrentDatasetOwner || !isWebFirstDataset) {
        allowedFeatures.push(...Object.values(AllFeatures));
    }
    return allowedFeatures.includes(type);
});
exports.hasDatasetWriteAccess = (0, reselect_1.createSelector)([
    auth_1.authSelectors.getCurrentDataset,
    datasets_1.datasetsSelectors.getDatasetsById,
    accountGroupsSelectors_1.isAccountGroupEnabled,
    accountGroupsSelectors_1.isEntityShareUser,
    accountGroupsSelectors_1.getCurrentAccountGroupName,
    accountGroupsSelectors_1.getAccountGroups,
], (currentDataset, datasetsById, acGroupEnabled, entitySharedUser, selectedAcGroupName, accountGroups) => {
    var _a, _b, _c, _d;
    const isShared = Boolean((currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.id) && ((_a = datasetsById.get(currentDataset.id)) === null || _a === void 0 ? void 0 : _a.shared));
    if (!isShared || !acGroupEnabled || !entitySharedUser) {
        return true;
    }
    const sharedAccountGroups = (0, accountGroupUtils_1.getSharedAccountGroups)(accountGroups, currentDataset);
    let selectedGroupsId;
    if (sharedAccountGroups.length > 1) {
        selectedGroupsId = (_b = sharedAccountGroups === null || sharedAccountGroups === void 0 ? void 0 : sharedAccountGroups.find((acOwner) => acOwner.name === selectedAcGroupName)) === null || _b === void 0 ? void 0 : _b.id;
    }
    else if (sharedAccountGroups.length === 1) {
        selectedGroupsId = sharedAccountGroups[0].id;
    }
    const writeAcGroupIds = (0, accountGroupUtils_1.deriveAccountGroupdIds)((_d = (_c = currentDataset.itemAccessControl) === null || _c === void 0 ? void 0 : _c.resources) === null || _d === void 0 ? void 0 : _d.ACCOUNT_GROUP, ['write']);
    return selectedGroupsId ? writeAcGroupIds.includes(selectedGroupsId) : false;
});
